import MapWrapper from './MapWrapper';

export default MapWrapper;